export const checkInCart=(cart , product)=>{
   if(cart)return cart.find((p) => p.id === product.id) 
}